var URI = {
	init: function () {
		var wh = window.location.href;
		var ac = wh.split('#/');

		if (typeof ac[1] === 'undefined') {
			var no = wh.split('/');
			if (!no[3]) {
				var no = no[3].split('?');
				if (no[0] != 'noticia') {
					window.location = '#/home';
				}
			}
		} else {
			URI.exec(ac[1]);
			//classe do menu superior
			$('.sh-menuitem-active').removeClass('sh-menuitem-active');
			if (ac[1] == 'camara/vereadores') {
				var id = ac[1].split('camara/');
				$('#' + id[1]).addClass('sh-menuitem-active');
			} else if (ac[1] == 'home') {
				$('#' + ac[1]).addClass('sh-menuitem-active');
			}
		}
	},

	change: function () {
		var wh = window.location.href;
		var ac = wh.split('#/');

		if (typeof ac[1] !== 'undefined') {
			$('.sh-menuitem-active').removeClass('sh-menuitem-active');
			URI.exec(ac[1]);
			//classe do menu superior
			if (ac[1] == 'camara/vereadores') {
				var id = ac[1].split('camara/');
				$('#' + id[1]).addClass('sh-menuitem-active');
			} else if (ac[1] == 'home') {
				$('#' + ac[1]).addClass('sh-menuitem-active');
			}
		}
	},

	exec: function (ac, title = undefined) {
		if (typeof title != 'undefined') document.title = window.changetitle;

		$('#content').html('').addClass('content-loading');
		$.post('/load', { action: ac }, function (r) {
			$('#content').html(r).removeClass('content-loading');
			var lazy_instance = $('.lazy').Lazy({
				afterLoad: function (element) {
					element.removeClass('lazy-loading');
				}
			});
		});
	}
};

window.onhashchange = function () {
	URI.change();
};
